import { Loader } from "@circle-react-uikit/Loader";
import { Modal } from "@circleco/compass/components/Modal";

export const EditPostLoader = () => (
  <Modal.Content>
    <Modal.Body>
      <div className="flex min-h-[400px] items-center justify-center">
        <Loader />
      </div>
    </Modal.Body>
  </Modal.Content>
);
